module.exports = __webpack_public_path__ + "static/media/rerun.fc1c3baa.svg";